import { Drawer, Input, Layout, Splitter } from "antd";
import styled from "styled-components";

const { Header, Sider } = Layout;
const { Search } = Input;

export const StyledHeaderSearchMinibar = styled(Search)`
  position: relative;
  max-width: 140px;
  min-height: 36px;
  margin-left: auto;
  margin-right: 10px;

  [dir="rtl"] & {
    margin-left: 10px;
    margin-right: auto;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
    margin-right: 20px;
    max-width: 165px;

    [dir="rtl"] & {
      margin-right: auto;
      margin-left: 20px;
    }
  }

  & .ant-input-wrapper {
    top: 50%;
    right: 0;
    z-index: 1;
    position: absolute;
    transform: translateY(-50%);

    [dir="rtl"] & {
      right: auto;
      left: 0;
    }
  }

  & .ant-input {
    padding: 8px 14px;
    height: 36px;
    transition: all 0.2s ease;
    width: 104px;

    &:focus {
      width: 135px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
      width: 129px;

      &:focus {
        width: 165px;
      }
    }
  }

  & .ant-input-search-button {
    height: 36px;
    width: 36px;
    box-shadow: none;

    & .anticon svg {
      display: block;
    }
  }

  &.ant-input-search-rtl
    > .ant-input-group
    > .ant-input-group-addon:last-child
    .ant-input-search-button {
    border-radius: ${({ theme }) => theme.sizes.borderRadius.base} 0 0
      ${({ theme }) => theme.sizes.borderRadius.base};
  }
`;

export const StyledAppLayout = styled(Layout)`
  display: flex;
  flex-direction: column !important;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const StyledAppLayoutSplitter = styled(Splitter)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const StyledHeaderPanel = styled(Splitter.Panel)`
  width: 100%;
`;
export const StyledBodyPanel = styled(Splitter.Panel)`
  width: 100%;
  overflow: hidden;
`;
export const StyledFooterPanel = styled(Splitter.Panel)`
  width: 100%;
`;
export const StyledHeader = styled(Header)<{ height: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-bottom: 2px solid ${({ theme }) => theme.palette.borderColor};
  height: ${({ height }) => height}px;
  padding: 5px 0px;
  padding-inline: 0px !important;
  padding-right: 10px !important;

  font-size: ${({ height }) => height / 2}px !important;
  line-height: 1 !important;

  img {
    height: ${({ height }) => height / 1.5}px;
  }
`;

export const StyledHeaderLeft = styled.div<{ mediaWidth: number }>`
  display: none;
  align-items: center;
  justify-content: space-between;
  min-width: 200px;
  height: inherit;
  padding: 0 10px;

  @media screen and (min-width: ${({ mediaWidth }) => mediaWidth}px) {
    display: flex;
  }
`;

export const StyledDrawerMenu = styled(Drawer)<{ headerHeight: number }>`
  .ant-drawer-body {
    padding: 0px !important;
  }

  .ant-drawer-header {
    height: ${({ headerHeight }) => headerHeight}px !important;
    padding: 5px !important;

    > .ant-drawer-header-title {
      height: inherit;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row-reverse;
    }
  }
`;

export const StyledHeaderLeftMobile = styled.div<{
  mediaWidth: number;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 50px;
  height: inherit;
  padding: 0 10px;

  @media screen and (min-width: ${({ mediaWidth }) => mediaWidth}px) {
    display: none;
  }
`;

export const StyledHeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 220px;
  width: 100%;
  padding: 0 10px;
  gap: 5px;

  > div {
    display: flex;
    gap: inherit;
  }
`;

export const StyledHeaderCollapseMenu = styled.div<{ height: number }>`
  display: flex;
  align-items: center;
  font-size: inherit;
  height: ${({ height }) => `${height}px`};

  svg {
    font-size: inherit;
  }
`;

export const StyledLayoutMain = styled(Splitter)<{ minusHeight: number }>`
  display: flex;
  flex-direction: row;
  height: calc(100vh - ${({ minusHeight }) => minusHeight}px) !important;
  width: 100vw !important;
  overflow: hidden;

  > .ant-splitter-panel:first-child {
    overflow: visible !important;
    &.ant-splitter-panel-hidden {
      overflow: hidden !important;
    }
  }
`;

export const StyledSidebar = styled(Sider)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100% !important;
  max-width: unset !important;
  min-width: unset !important;
  overflow: visible !important;
  position: relative;
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

export const StyledSidebarPanel = styled(Splitter.Panel)`
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-right: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

export const StyledSidebarMenu = styled.div<{ width: number }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  width: ${({ width }) => width}px;
  height: 100%;
  background: ${({ theme }) => theme.palette.background.sidebar};

  &:hover .main-sidebar-collapse-btn {
    display: flex;
  }
`;

export const StyledSidebarFooter = styled.div<{ collapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ collapsed }) => (collapsed ? "center" : "flex-start")};
  width: 100%;
  transition: all 0.4s ease;
  background-color: ${({ theme }) =>
    theme.palette.background.default} !important;
  padding: ${({ collapsed }) => (collapsed ? "4px 0px" : "3px 10px")};

  .ant-typography {
    transition: all 1.5s ease;
    font-size: ${({ collapsed }) => (collapsed ? "8px" : "12px")};
  }
`;

export const StyledLayoutContent = styled(Splitter.Panel)`
  flex: 1;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  margin: 0px !important;
`;

export const StyledRightPanel = styled(Splitter.Panel)`
  height: 100%;
  overflow: auto;
  border-left: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

export const StyledRightPanelContent = styled.div`
  height: 100%;
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledFooterAppMenu = styled.div`
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 50px;
  width: min-content;
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
  margin: 0 auto;
`;

export const StyledFooterAppMenuBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.background.paper};
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);

  svg {
    font-size: 24px;
  }
`;

export const StyledFooterNavBtn = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: ${({ theme, isActive }) =>
    isActive ? theme.palette.primary.main : theme.palette.background.paper};
  color: ${({ theme, isActive }) =>
    isActive ? theme.palette.primary.contrastText : theme.palette.text.primary};
  border: 1px solid
    ${({ theme, isActive }) =>
      isActive ? theme.palette.primary.main : theme.palette.borderColor};
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.contrastText};
    transform: scale(1.1);
  }

  svg {
    font-size: 18px;
  }
`;
